import {
  formatDate,
  filterDate,
  filterTime,
  renderSize,
  filterLock,
  filterOrdersStatus,
  filterVipTypes,
  filterUpdateTypes,
  filterFeeTypes,
  filterGiftTypes,
  filterGiftStatus,
  filterRepeat,
  filterReply,
  filterSource,
  filterGiftType,
  filterActionType,
  filterUserRoleTag,
  filterUserRoleEngine,
  filterWriteTemplateCategory,
} from "./filter";
import api from "../api";
import cookie from "js-cookie";
import lodash from "lodash";
import message from "../mixins/element";
import VueUploadComponent from "vue-upload-component";
import timApi from "../utils/timApi";

export default {
  install(Vue, options) {
    //  数据格式化
    Vue.filter("filterLock", filterLock);
    Vue.filter("filterRepeat", filterRepeat);
    Vue.filter("filterReply", filterReply);
    Vue.filter("filterSource", filterSource);
    Vue.filter("filterOrdersStatus", filterOrdersStatus);
    Vue.filter("filterUpdateTypes", filterUpdateTypes);
    Vue.filter("filterVipTypes", filterVipTypes);
    Vue.filter("filterFeeTypes", filterFeeTypes);
    Vue.filter("filterGiftTypes", filterGiftTypes);
    Vue.filter("filterGiftStatus", filterGiftStatus);
    Vue.filter("filterGiftType", filterGiftType);
    Vue.filter("filterActionType", filterActionType);
    Vue.filter("filterWriteTemplateCategory", filterWriteTemplateCategory);
    //  时间过滤
    Vue.filter("formatDate", formatDate);
    Vue.filter("filterDate", filterDate);
    Vue.filter("filterTime", filterTime);
    //  文件大小过滤
    Vue.filter("renderSize", renderSize);
    // 用户权限相关
    Vue.filter("filterUserRoleTag", filterUserRoleTag);
    Vue.filter("filterUserRoleEngine", filterUserRoleEngine);

    // 信息提示
    Vue.mixin(message);
    //  上传组件
    Vue.component("file-upload", VueUploadComponent);
    //  api && cookie
    Vue.prototype.$http = api;
    Vue.prototype.$_ = lodash;
    Vue.prototype.$cookie = cookie;
    Vue.prototype.$tim = timApi;
    //  取消生产提示
    Vue.config.productionTip = false;
  },
};
